import axios from "axios";
import moment from "moment";
import "moment-timezone";
import store from "../../redux/store";
import { Tracker } from "./analytics";
import {
  API_DATE_FORMAT,
  API_ENDPOINTS,
  DATE_SETTINGS,
  FILTER_TYPES,
} from "./constants";
import { actions } from "../modules/Dashboard/_redux/dashboardRedux";
export const testMode = !(window && window.matchMedia);

// Helper functions to set, get, and remove cookies
export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = (name) => {
  document.cookie = `${name}=; Max-Age=-99999999;`;
};
export const getAuthToken = () => {
  return getCookie('authToken');
};
export const isMobile =
  window && window.matchMedia
    ? window.matchMedia("(max-width: 425px)").matches
    : true;

export const blockInvalidChar = (e) => ['E', 'e', '>', '<', '`' ,'!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '-', '_', '+', '=', '[', ']', '{', '}', '|', '\\', ';', ':', "'", '"', ',', '.', '/', '?'].includes(e.key) && e.preventDefault();

export function printAccountInfo() {
  const {
    auth: { role, is_callcenter_enabled, is_hierarchy_enabled, is_mpls },
  } = store.getState();

  return [
    { key: "Role", value: role },
    { key: "Is CC", value: is_callcenter_enabled === true ? "true" : "false" },
    {
      key: "Hiearchy",
      value: is_hierarchy_enabled === true ? "true" : "false",
    },
    { key: "Is MPLS Acct", value: is_mpls === true ? "true" : "false" },
  ];
}

export function getAgentTimer() {
  const {
    auth: { agentTimer },
  } = store.getState();

  return agentTimer;
}
// export function getAuthToken() {
//   const {
//     auth: { authToken },
//   } = store.getState();

//   return authToken;
// }
export function isLoggedIn() {
  const {
    auth: { user },
  } = store.getState();

  return user !== null && user !== undefined ? true : false;
}

export function getUser() {
  const {
    auth: { user },
  } = store.getState();

  return user;
}

export function getAccountId() {
  const {
    auth: { profile },
  } = store.getState();

  return profile ? profile.account_id : false;
}

export function isCountryIndia() {
  const {
    auth: { profile },
  } = store.getState();

  return profile && profile.country_details 
    ? (profile.country_details.country_name ? profile.country_details.country_name.toLowerCase() === "in" : false) 
    : false;
}

var timeoutId = null;

export function wsKonnectSyncTracker(key, value) {
  const keySet = key == 'wsKey' ? 'konnectKey' : 'wsKey';
  sessionStorage.setItem(key, value);
  if (!timeoutId) {
    timeoutId = setTimeout(() => {
      if(document.hidden) { 
        sessionStorage.removeItem("wsKey");
        sessionStorage.removeItem("konnectKey");
        clearTimeout(timeoutId);
        timeoutId = null;
        return;
      }
      const missingValue = sessionStorage.getItem(keySet);
      if (!missingValue) {
        Tracker.event(
          "WS_Konnect",
          "event_missing",
          `${value}__${moment().format('DD-MM-YY hh:mm:ss A')}__missing__${keySet}`,
          `${value}__${moment().format('DD-MM-YY hh:mm:ss A')}__missing__${keySet}`,
          getUser()
        );
      }
      sessionStorage.removeItem("wsKey");
      sessionStorage.removeItem("konnectKey");
      clearTimeout(timeoutId);
      timeoutId = null;
    }, 10000);
  }
}

const createOldSRIframe = async (src, data) => {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.style.border = 'none';
    iframe.style.position = 'absolute';
    iframe.style.top = '-1px';
    iframe.style.left = '-1px';
    iframe.id = 'old_sr_iframe';   // unique ID to the Old SR iframe
    document.body.appendChild(iframe);

    iframe.onload = () => {
      const iframeWindow = iframe.contentWindow;
      const targetOrigin = new URL(iframe.src).origin;
      iframeWindow.postMessage(data, targetOrigin);
      resolve();
    };

    iframe.onerror = (error) => {
      reject(error);
    };
  });
};

const logOutFromOldSR = async (data) => {
  const iframeElement = document.getElementById('old_sr_iframe') || null;       // unique ID to the Old SR iframe
  if (!iframeElement) {
    return await createOldSRIframe(process.env.REACT_APP_IFRAME_BASE_URL+'#/?iframeCheck=true', data);  // Making an iframe, if not found in DOM.
  } else {
  const iframeWindow = iframeElement.contentWindow;
  const targetOrigin = new URL(iframeElement.src).origin;
  return await iframeWindow.postMessage(data, targetOrigin);
  }
}

export const authLogoutSession = (dispatch, callback = null) => {
  try {
    dispatch(actions.setLoadingState({ resource: 'iframe_logout', loading_state: 'loading' }));   // Start the loader
    logOutFromOldSR({ logout: true }).then((res) => {     // This will be called in case of 401 and "Invalid token"
      window.addEventListener("message", (event) => {
        if (event.data == 'old_sr_logout_success') {
          dispatch(actions.setLoadingState({ resource: 'iframe_logout', loading_state: 'loaded' }));  // stop the loader, once message recieved
          if (callback) {
            callback();                            // This callback should have logout logic.
            return;
          }
          setTimeout(() => {                       // Awaiting response from oldSR for logout, so we can logout newSR as well
            localStorage.clear();
            window.location.href = process.env.REACT_APP_IFRAME_BASE_URL;
          }, 10);
        }
      });
    });
  } catch (e) {
    dispatch(actions.setLoadingState({ resource: 'iframe_logout', loading_state: 'loaded' }));  // Stop the loader, fail-safe !
  };
}

export const logoutCallback = (authFail = false) => {
  try {
    const { auth: { user } } = store.getState();
    setTimeout(() => {  
      Tracker.event_v2(
        "AUTH",
        "logout",
        "Logout success",
        `${authFail ? "token-expired-logout" : "site-logout-success"}`,
        { user: user }
      );
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = process.env.REACT_APP_IFRAME_BASE_URL;
    }, 10);
  } catch (error) {
    console.log(error, "Something went wrong !!")
  }
}

export function getUserApiKey() {
  return getCookie('user_api_key');
 
}

export function isCustomInfoEnabled() {
  const {
    auth: { profile },
  } = store.getState();

  return profile && profile.is_show_custom_info
    ? profile.is_show_custom_info
    : false;
}

export function isAutoOpenUrl() {
  const {
    auth: { profile },
  } = store.getState();

  return profile && profile.is_auto_open_url
    ? profile.is_auto_open_url
    : false;
}

export function getUserTimezone() {
  const {
    auth: { profile },
  } = store.getState();
  return profile ? profile.timezone : false;
}

export function srmoment() {
  return moment(); //.tz(getUserTimezone())
}
export function isAdmin() {
  const {
    auth: { role },
  } = store.getState();

  return role === "admin" ? true : false;
}

export function isSuperVisor() {
  const {
    auth: { role },
  } = store.getState();

  return role === "supervisor" ? true : false;
}

export function isAgent() {
  const {
    auth: { role },
  } = store.getState();

  return role === "agent" ? true : false;
}

export function isCallCenterEnabled() {
  const {
    auth: { is_callcenter_enabled },
  } = store.getState();

  return is_callcenter_enabled;
}

export function isSMSLogsEnabled() {
  const {
    auth: { is_sms_enabled },
  } = store.getState();
  return is_sms_enabled;
}

export function getUserStatusTickerColor() {
  if (!isCallCenterEnabled()) return false;
  const {
    auth: { status_color },
  } = store.getState();
  return status_color ? status_color : false;
}

export function is_disposition_enabled() {
  const {
    auth: { is_disposition_enabled },
  } = store.getState();

  return true;

  return is_disposition_enabled;
}

export function isSSO() {
  const {
    auth: { is_sso },
  } = store.getState();
  return is_sso;
}

export function isHierarchyEnabled() {
  const {
    auth: { is_hierarchy_enabled },
  } = store.getState();

  return is_hierarchy_enabled;
}

export function getPageFilters() {
  const {
    auth: { filters },
  } = store.getState();

  return filters;
}

export function getAuthState() {
  return store.getState().auth;
}

export function getSelectedSolutionOptions() {
  const {
    auth: { selectedSolutionOptions },
  } = store.getState();

  return selectedSolutionOptions;
}

export function getSelectedSolutionOptionsForCallLogs() {
  const {
    auth: { selectedSolutionOptionsForCallLogs },
  } = store.getState();

  return selectedSolutionOptionsForCallLogs;
}

export function getSelectedPlanOptions() {
  const {
    auth: { selectedPlanOptions },
  } = store.getState();

  return selectedPlanOptions;
}

export function getSelectedNumberOptions() {
  const {
    auth: { selectedNumberOptions },
  } = store.getState();

  return selectedNumberOptions;
}

export function isFeatureEnabledProfile(key) {
    const {
        auth: { profile, extra_data }
    } = store.getState();

    if(key == 'hide_iframe_redirection') {
        if (extra_data && extra_data.hide_iframe_redirection) return true;
        return false;
    }
    if(profile && profile[key]) {
        return profile[key]
    } else {
        return false
    }
}

export function isCPSettingsAvailable(key) {
  const {
      auth: { profile }
  } = store.getState();

  return profile?.cp_settings?.[key] === "True" ?? false;

}

export function isUIParamsAvailable(key) {
  const {
      auth: { profile }
  } = store.getState();

  return profile?.ui_params?.[key] ?? false;

}

export function isAccountSettingsEnabled() {

  const showAccountSettings = (
    isFeatureEnabledProfile('kyc_enabled') &&
    !isCPSettingsAvailable('account_settings') && 
    !isFeatureEnabledProfile('is_suspended_account') && 
    isFeatureEnabledProfile('suspension_type') !== 'coin'
  );

  return showAccountSettings;
}

export function isAccountInvoicesEnabled() {

  const showAccountInvoices = (
  ( (!isCPSettingsAvailable('account_invoices') &&
    isFeatureEnabledProfile('show_invoice_to_user'))  || (!isCPSettingsAvailable('account_invoices') &&
    isAdmin()) )
    );

  return showAccountInvoices;
}

export function isAccountBillingSummaryEnabled() {

  const showBillingSummary = (
    ((!isCPSettingsAvailable('account_billing_summary') &&
    isFeatureEnabledProfile('show_invoice_to_user')) ||(!isCPSettingsAvailable('account_billing_summary') &&
    isAdmin()))
    );

  return showBillingSummary;
}

export function isAccountHistoryEnabled() {

  const showHistorySecondCase = (
    !isCPSettingsAvailable('account_history') && 
    !isFeatureEnabledProfile('is_suspended_account') && 
    isFeatureEnabledProfile('selfserve_enabled')
  );

  return showHistorySecondCase;
}

export function isPaymentsTabEnabled() {
  const hidePaymentsRoute = (
    isFeatureEnabledProfile('generate_system_invoice') ||
    (isFeatureEnabledProfile('billing_type') == 'prepaid' || isFeatureEnabledProfile('billing_type') == 'None') &&
    isFeatureEnabledProfile('kyc_final_state') !== 1
  );

  const showPaymentsRoute = (
    !isCPSettingsAvailable('account_payments') &&
    !isFeatureEnabledProfile('generate_system_invoice')
  );

  return !hidePaymentsRoute && showPaymentsRoute;
}

export function isHierarchyEnabledAccount() {
  const showHierarchy = (isAdmin() && isFeatureEnabledProfile('enable_detailed_hierarchy_insights') && !isFeatureEnabledProfile('hide_iframe_redirection'));
  return showHierarchy;
}

export function getSelectedPlans() {
  const {
    auth: { selectedPlans },
  } = store.getState();

  return selectedPlans;
}

export function getSelectedNumbers() {
  const {
    auth: { selectedNumbers },
  } = store.getState();

  return selectedNumbers;
}

export function getSelectedPlansForSMS() {
  const {
    auth: { selectedPlansForSMS },
  } = store.getState();

  return selectedPlansForSMS;
}

export function getSelectedNumberOptionsForSMS() {
  const {
    auth: { selectedNumberOptionsForSMS },
  } = store.getState();

  return selectedNumberOptionsForSMS;
}

export function getSelectedNumbersForSMS() {
  const {
    auth: { selectedNumbersForSMS },
  } = store.getState();

  return selectedNumbersForSMS;
}

export function getSelectedDispositionsForCallLogs() {
  const {
    auth: { disposition },
  } = store.getState();

  return disposition;
}
export function getSelectedSolutionsForCallLogs() {
  const {
    auth: { selectedSolutionsForCallLogs },
  } = store.getState();

  return selectedSolutionsForCallLogs;
}

export function getAllAgentsForCallLogsFilter() {
  const {
    auth: { agent_names_call_logs_filter },
  } = store.getState();

  return agent_names_call_logs_filter;
}

export function getAllCampaignsForCallLogs() {
  const {
    auth: { compaigns },
  } = store.getState();

  return compaigns;
}

export function getSelectedPlansForCallLogs() {
  const {
    auth: { selectedPlansForCallLogs },
  } = store.getState();

  return selectedPlansForCallLogs;
}

export function getSelectedNumberOptionsForCallLogs() {
  const {
    auth: { selectedNumberOptionsForCallLogs },
  } = store.getState();

  return selectedNumberOptionsForCallLogs;
}

export function getSelectedNumbersForCallLogs() {
  const {
    auth: { selectedNumbersForCallLogs },
  } = store.getState();

  return selectedNumbersForCallLogs;
}

export function getLogLevels() {
  const {
    dashboard: { log_levels },
  } = store.getState();

  return log_levels;
}

export function getSearchFilters() {
  const {
    agentsActivityListingsSlice: { filters },
  } = store.getState();

  return filters;
}

export function getQueryParams() {
  const {
    agentsActivityListingsSlice: { queryParams },
  } = store.getState();

  return queryParams;
}

export function serverLogout() {
  let authToken = getAuthToken();
  let user = getUser();
  try {
    let loggedIn = user != null && user !== undefined;
    if (loggedIn) {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      axios
        .get(`${process.env.REACT_APP_API_ENDPOINT_BASE_URL}/vr/logout`, {
          headers: headers,
        })
        .then((val) => {
          Tracker.event_v2(
            "AUTH",
            "logout",
            "Logout success",
            "site-logout-success",
            { user: user }
          );
        })
        .catch((err) => {
          Tracker.event_v2(
            "AUTH",
            "logout",
            "Logout success",
            "site-logout-success",
            { user: user }
          );
        });
    }
  } catch (error) {
    Tracker.event("AUTH", "logout", "Logout Error", "site-logout-error", {
      user: user,
    });
  }
}

export const isTickerModuleEnabled = () => {
  return isFeatureEnabled("ticker");
};

export const isCallLogsModuleEnabled = () => {
  return `${process.env.REACT_APP_CALL_LOGS_ENABLED}` === "Y" ? true : false;
};

export const isTickerFeatureEnabled = async () => {
  return true;
};

/**
 *
 * @param {{"call_logs":0,"sms_logs":0
 * ,"customer_management":0,"queue_monitoring":0, "is_callticker_activated"})} feature
 * @returns
 */
export const isFeatureEnabled = (featureId) => {
  let feature = featureId;
  if (feature === "ticker") return true;

  const {
    auth: { profile },
  } = store.getState();

  const {
    auth: { extra_data },
  } = store.getState();

  if (featureId === "is_callticker_activated") {
    if (profile && profile[featureId] === true) {
      return true;
    }
    return false;
  }

  if (featureId === "is_dialpad_enabled") {
    if (extra_data && extra_data[featureId] == true) {
      return true;
    }
    return false;
  }

  return true;

  if (featureId === "is_new_live_ticker_enabled") {
    if (extra_data && extra_data.is_new_live_ticker_enabled) {
      return true;
    }
    return false;
  }

  if (featureId === "is_device_enabled") {
    if (extra_data && extra_data.is_new_live_ticker_enabled) {
      return true;
    }
    return false;
  }

  if (profile && profile.extra_data && profile.extra_data[feature]) {
    return true;
  }
  return false;
};

export const isMultiAgentEnabled = () => {
  const {
    auth: { multiagent },
  } = store.getState();
  return multiagent;
};

export const isNumberMaskingEnabled = () => {
  const {
    auth: { number_masking },
  } = store.getState();
  return number_masking;
};

export const getUserQueueList = () => {
  const {
    auth: { user_queue_list },
  } = store.getState();
  return user_queue_list;
};

export const getDispositions = async () => {
  const url = API_ENDPOINTS.getDispositions;
  try {
    const params = { group_id: "all" };

    const response = await axios.get(url, { params: params });
    return response;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};
export const getUserSettingsData = async (value) => {
  const url = API_ENDPOINTS.getUserSettings;
  let newresponse=false
  try {
    const params = { property: value };

    const response = await axios.get(url, { params: params });
    if (response.data.objects.length>0){
      newresponse=response.data.objects[0].value
    }
    else{
      newresponse=false
    }
    return newresponse;
  } catch (error) {
    console.error(error);
    return error.response;
  }
};

export const isEnterpriseSIVR = () => {
  const { auth: { plans } } = store.getState();
  let isExist = false;
  if (plans && plans.objects) {
    plans.objects.map((plan) => {
      if (plan.plan.plan_name.includes("Enterprise SIVR"))
        plan.numbers.map((number) => {
          if (!number.is_expired) isExist = true;
        });
    });
  }
  return isExist
}

export const getModule = (location) => {
  if (location.pathname === "/smslogs") {
    return "smslogs";
  }
  if (location.pathname === "/call-logs") {
    return "call-logs";
  }
  if (location.pathname === "/dashboard") {
    return "dashboard";
  }
  if (location.pathname === "/insights") {
    return "insights";
  }
  if (location.pathname === "/customer-management") {
    return "crm";
  }

  if (location.pathname === "/customer-management/customer") {
    return "crm-customer";
  }
};

let queueMappingDataPacket = {};
export const queueMappingData = async (dispatch, actions) => {
  return await queueMappingDataPacket;
};

export const getAgentsAndQueuesByAccount = async (user, checkStatus) => {
  const url = API_ENDPOINTS.getAgentsQueueInfo;
  try {
    if (!user) {
      return { queues: [], agents: [] };
    }

    const params = { user_id: getAccountId() };
    const response = await axios.get(url, { params: params });
    if (checkStatus === true) {
      const queueData = response.data["details"];
      var queues = queueData && queueData.queues ? queueData.queues : [];

      for (var i = 0; i < queues.length; i++) {
        let queue = queues[i];

        let queueAgents = queueData.agents.filter(
          (data) => data.queue === queues[i].q_uuid
        );
        let queueAgentsAvailableList = queueAgents.filter(
          (data) => data.status === "Available"
        );
        let queueAgentsOnBreakList = queueAgents.filter(
          (data) => data.status === "On Break"
        );
        let queueAgentsLoggedOutList = queueAgents.filter(
          (data) => data.status === "Logged Out"
        );

        queue.status = "notavailable";

        if (queueAgents.length === 0) {
          queue.status = "notavailable";
        } else if (queueAgentsAvailableList.length > 0) {
          queue.status = "available";
        } else if (
          queueAgentsOnBreakList.length > 0 &&
          queueAgentsOnBreakList.length === queueAgents.length
        ) {
          queue.status = "onbreak";
        } else if (
          queueAgentsLoggedOutList.length > 0 &&
          queueAgentsLoggedOutList.length === queueAgents.length
        ) {
          queue.status = "loggedout";
        }
      }
      return queues;
    }
    return {
      queues: response.data["details"]["queues"],
      agents: response.data["details"]["agents"],
    };
  } catch (error) {
    console.error("getAgentsQueueInfo :", error);
    return { queues: [], agents: [] };
  }
};

export const getAgentQueueInfoAsObjectsListByAccount = async (
  user,
  checkStatus
) => {
  const url = API_ENDPOINTS.getAgentsQueueInfo;
  try {
    if (!user) {
      return [];
    }

    const params = { user_id: getAccountId() }; //'188221' }
    const response = await axios.get(url, { params: params });
    const list = {};

    if (checkStatus === true) {
      const queueData = response.data["details"];
      var queues = queueData && queueData.queues ? queueData.queues : [];

      for (var i = 0; i < queues.length; i++) {
        let queue = queues[i];

        let queueAgents = queueData.agents.filter(
          (data) => data.queue === queues[i].q_uuid
        );
        let queueAgentsAvailableList = queueAgents.filter(
          (data) => data.status === "Available"
        );
        let queueAgentsOnBreakList = queueAgents.filter(
          (data) => data.status === "On Break"
        );
        let queueAgentsLoggedOutList = queueAgents.filter(
          (data) => data.status === "Logged Out"
        );

        queue.status = "notavailable";

        if (queueAgents.length === 0) {
          queue.status = "notavailable";
        } else if (queueAgentsAvailableList.length > 0) {
          queue.status = "available";
        } else if (
          queueAgentsOnBreakList.length > 0 &&
          queueAgentsOnBreakList.length === queueAgents.length
        ) {
          queue.status = "onbreak";
        } else if (
          queueAgentsLoggedOutList.length > 0 &&
          queueAgentsLoggedOutList.length === queueAgents.length
        ) {
          queue.status = "loggedout";
        } else {
        }
      }
      return queues;
    }
    return response.data["details"]["queues"];
  } catch (error) {
    console.error("getAgentsQueueInfo :", error);
    return [];
  }
};

export const getAgentQueueInfoAsObjectsList = async (user) => {
  const url = API_ENDPOINTS.getAgentsQueueInfo;
  try {
    if (!user) {
      return [];
    }

    const params = { user_id: user.user_id }; //'188221' }
    const response = await axios.get(url, { params: params });
    const list = {};

    return response.data["details"]["queues"];
  } catch (error) {
    console.error("getAgentsQueueInfo :", error);
    return [];
  }
};

export const getAgentQueueInfo = async (user) => {
  try {
    const map = {};
    const list = await getAgentQueueInfoAsObjectsList(user);

    list.map((queue) => {
      map[queue["q_uuid"]] = queue["name"];
    });

    return map;
  } catch (error) {
    console.error("getAgentsQueueInfo :", error);
    return {};
  }
};

export const getAgentQueueInfoAsObjectsListByAccountId = async (
  accountId,
  user
) => {
  const url = API_ENDPOINTS.getAgentsQueueInfo;
  try {
    if (!user) {
      return [];
    }
    const params = { user_id: getAccountId() };
    const response = await axios.get(url, { params: params });
    queueMappingDataPacket = response ? response.data["details"] : {};
    return response.data["details"]["queues"];
  } catch (error) {
    console.error("getAgentsQueueInfo :", error);
    return [];
  }
};

export const getAgentQueueInfoByAccountId = async (accountId, user) => {
  try {
    const map = {};
    const list = await getAgentQueueInfoAsObjectsListByAccountId(
      accountId,
      user
    );

    list.map((queue) => {
      map[queue["q_uuid"]] = queue["name"];
    });

    return map;
  } catch (error) {
    console.error("getAgentsQueueInfo :", error);
    return {};
  }
};

export const resetPage = (dispatch) => {
  const date_filter = DATE_SETTINGS.filters.today;
  var currentDate = srmoment();
  let to_date = currentDate.toDate();
  var dayStart = currentDate.clone().startOf("day");
  var from_date = dayStart.toDate();

  let pageFilters = getPageFilters();
  pageFilters = {
    ...pageFilters,
    filters: {
      solutions: [],
      plans: [],
      numbers: [],
      selectedSolutionOptions: false,
      selectedPlanOptions: false,
      selectedNumberOptions: false,
      filter_type: null,
      date_filter: { code: "today" },
      from_date: null,
      to_date: null,
      from_date_fmt: null,
      to_date_fmt: null,
      refresh: null,
    },
    selectedSolutions: [],
    selectedPlans: [],
    selectedNumbers: [],
  };

  pageFilters.filter_type = FILTER_TYPES.dates_filter;
  pageFilters.date_filter = date_filter;
  pageFilters.from_date = from_date;
  pageFilters.to_date = to_date;
  pageFilters.from_date_fmt = from_date
    ? moment(from_date).format(API_DATE_FORMAT)
    : null;
  pageFilters.to_date_fmt = to_date
    ? moment(to_date).format(API_DATE_FORMAT)
    : null;

  var changelog = {};
  changelog.filter_type = FILTER_TYPES.dates_filter;
  changelog.date_filter = date_filter;
  changelog.from_date = from_date;
  changelog.to_date = to_date;
  changelog.from_date_fmt = from_date
    ? moment(from_date).format(API_DATE_FORMAT)
    : null;
  changelog.to_date_fmt = to_date
    ? moment(to_date).format(API_DATE_FORMAT)
    : null;
  pageFilters.changelog = changelog;

  const action1 = {
    type: "[MainFilters] Set Filter",
    payload: { ...pageFilters },
  };
  dispatch(action1);
};

export const resetInsightsPage = (dispatch) => {
  return resetPage(dispatch);
};

export const resetCallLogsPage = (dispatch) => {
  const date_filter = DATE_SETTINGS.filters.today;
  var currentDate = srmoment();
  let to_date = currentDate.toDate();
  var dayStart = currentDate.clone().startOf("day");
  var from_date = dayStart.toDate();

  let pageFilters = getPageFilters();
  pageFilters = {
    ...pageFilters,
    filters: {
      solutions: [],
      plans: [],
      numbers: [],
      selectedSolutionOptions: false,
      selectedPlanOptions: false,
      selectedNumberOptions: false,
      filter_type: null,
      date_filter: { code: "today" },
      from_date: null,
      to_date: null,
      from_date_fmt: null,
      to_date_fmt: null,
      refresh: null,
    },
    selectedSolutions: [],
    selectedPlans: [],
    selectedNumbers: [],
    selectedSolutionOptions: false,
    selectedPlanOptions: false,
    selectedNumberOptions: false,
    filter_type: null,
    date_filter: { code: "today" },
    from_date: null,
    to_date: null,
    from_date_fmt: null,
    to_date_fmt: null,
    refresh: null,
  };

  pageFilters.filter_type = FILTER_TYPES.dates_filter;
  pageFilters.date_filter = date_filter;
  pageFilters.from_date = from_date;
  pageFilters.to_date = to_date;
  pageFilters.from_date_fmt = from_date
    ? moment(from_date).format(API_DATE_FORMAT)
    : null;
  pageFilters.to_date_fmt = to_date
    ? moment(to_date).format(API_DATE_FORMAT)
    : null;

  var changelog = {};
  changelog.filter_type = FILTER_TYPES.dates_filter;
  changelog.date_filter = date_filter;
  changelog.from_date = from_date;
  changelog.to_date = to_date;
  changelog.from_date_fmt = from_date
    ? moment(from_date).format(API_DATE_FORMAT)
    : null;
  changelog.to_date_fmt = to_date
    ? moment(to_date).format(API_DATE_FORMAT)
    : null;
  pageFilters.changelog = changelog;

  const action1 = {
    type: "[MainFilters] Set Filter",
    payload: { ...pageFilters },
  };
  dispatch(action1);
};


export const getLiveCallUrl = async () => {
  let live_call_url = process.env.REACT_APP_AGENT_STATUS_API_URL
  if(await getUserSettingsData("new_live_call_url")){
    live_call_url = process.env.REACT_APP_AGENT_STATUS_API_URL_NEW
  }
  return live_call_url
};

export const isDateInRange = (start, end) => {
  const currentDate = new Date();
  const startDateRange = new Date(start);
  const endDateRange = new Date(end);
  return startDateRange <= currentDate && currentDate <= endDateRange;
};